/**
 * Which shell this bundle is running in.
 *
 * The distinction matters in exactly one place and it is not cosmetic: the
 * backend's X-App-Version check compares the client's build SHA against the
 * deployed Lambda's. That is a real and useful check for a web page, which is
 * rebuilt and redeployed alongside the backend and can fix itself by
 * reloading.
 *
 * A store binary is frozen at the commit it was built from and lives for
 * months while the backend redeploys independently. Under the same check the
 * first backend deploy after a release makes every write fail, and reloading
 * -- the web remedy -- re-runs the identical bundle. So a native build declares
 * a numeric API contract version instead, and the backend serves anything at
 * or above the floor it still supports.
 */

/**
 * Raise only alongside a backend MIN_NATIVE_API_VERSION bump, and only for a
 * genuinely breaking change: every bump strands installed apps until their
 * owners update, which is days to weeks for a store release.
 */
export const API_CONTRACT_VERSION = 1;

function detectNative() {
  if (typeof window === 'undefined') return false;
  // Capacitor injects this global before any application code runs.
  if (window.Capacitor?.isNativePlatform?.()) return true;
  if (window.Capacitor?.isNative) return true;
  // Cordova, and the scheme a WKWebView serves the bundle from.
  if (window.cordova) return true;
  const scheme = window.location?.protocol || '';
  return scheme === 'capacitor:' || scheme === 'ionic:';
}

export const IS_NATIVE = detectNative();
